import { render, staticRenderFns } from "./PelatihanEvaluasiFasilitator.vue?vue&type=template&id=12ab027f"
import script from "./PelatihanEvaluasiFasilitator.vue?vue&type=script&lang=js"
export * from "./PelatihanEvaluasiFasilitator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports